import React from 'react';
import {useTransition, animated} from 'react-spring';
import PropTypes from 'prop-types';

const MenuMount = ({nav, tabs}) => {

    const menuStyle = useTransition(nav, {
        from: {height: "100vh", width: "100vw", opacity:1, left:"-20rem", pointerEvents: "none"},
        enter: {opactiy:1, left:"0rem", pointerEvents: "auto"},
        leave: {opacity:0, left:"-20rem", pointerEvents: "none"},
        reverse: nav,
    });

    return menuStyle((styles, item) => item && <animated.div style={{...styles}} className="nav-small">
            {tabs}
        </animated.div>
    )
}

MenuMount.propTypes = {
    nav: PropTypes.bool,
    Tabs: PropTypes.array,
    socialMedia: PropTypes.array,
}

export default MenuMount;